import type {
    AppVersionChannel,
    AppVersionContents,
    AppVersionUpdateItem,
    AppVersionUpdateType,
} from '@/services/app-version-updates';

export type ChannelFormValue = {
    enabled: boolean;
    version_name: string;
    download_url: string;
};

export type AppVersionFormValues = {
    type: AppVersionUpdateType;
    ios: ChannelFormValue;
    android: ChannelFormValue;
    apk: ChannelFormValue;
    contents: AppVersionContents;
};

export type TimePreset = 'all' | '7d' | '30d' | 'custom';

export type ListSearchFilters = {
    type?: AppVersionUpdateType | '';
    channel?: AppVersionChannel | '';
    status?: 'Enabled' | 'Disabled' | '';
    timePreset?: TimePreset;
    created_at_range?: [string, string];
};

export type ModalMode = 'create' | 'edit';

export type PublishEditModalState = {
    open: boolean;
    mode: ModalMode;
    record?: AppVersionUpdateItem;
};

export const I18N_LOCALES = ['zh', 'en', 'ja', 'es', 'vi', 'tr'] as const;
export type I18nLocale = (typeof I18N_LOCALES)[number];

export const CHANNEL_KEYS = ['ios', 'android', 'apk'] as const;
export type ChannelKey = (typeof CHANNEL_KEYS)[number];
